/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/


export default {
  ADD_TO_ENDORSEMENT_INVITE_EMAIL_LIST (state, email) {
    state.emailList.push(email)
  },
  REMOVE_FROM_ENDORSEMENT_INVITE_EMAIL_LIST (state, email) {
    const emailIndex = state.emailList.findIndex(ch => ch === email)
    state.emailList.splice(emailIndex, 1)
  },
  SET_PROGRESS_MEASURE (state, progressMeasure) {
    state.progressMeasure = progressMeasure
  },
  SET_QUESTION_VALUE (state, question) {
    const questionIndex = state.answers.findIndex(ch => ch.question === question.question)
    if (questionIndex === -1) {
      state.answers.push(question)
    } else {
      state.answers.splice(questionIndex, 1)
      state.answers.push(question)
    }
  },
  SET_PROGRESS_VALUE (state, value) {
    state.progress = value
  },
  SET_PRACTICE_VALUE (state, value) {
    state.practice = value
  },
  SET_RELEVANCY_VALUE (state, value) {
    state.relevancy = value
  },
  SET_SKIP_VALUE (state, value) {
    state.skip = value
  },
  DESTROY_PROGRESS(state) {
    state.progress = 100
  },
  DESTROY_PRACTICE(state) {
    state.practice = 100
  },
  DESTROY_RELEVANCY(state) {
    state.relevancy = 100
  },
  DESTROY_SKIP(state) {
    state.skip = true
  }
}
